module.exports = __webpack_public_path__ + "static/media/check_mark.b074af42.svg";